import { SupabaseClient, User } from "@supabase/supabase-js";

import { Database } from "@punchup/data/supabase.types";
import { createClientComponentClient } from "@punchup/data/supabase/client";

// Keep this in sync with nuxs table in supabase
export enum NuxSlug {
  NavLinkLibrary = "navlink-library",
  NavLinkDashboard = "navlink-dashboard",
}

export async function shouldDisplayNux(
  user: User,
  slug: NuxSlug
): Promise<boolean> {
  const supabase = createClientComponentClient<Database>();

  const { count, error } = await supabase
    .from("user_nux_views")
    .select("user_id", { count: "exact" })
    .eq("user_id", user.id)
    .eq("nux_slug", slug);

  if (error) {
    throw new Error(`Error finding nux view ${slug} for user ${user.id}`);
  }

  return count === 0;
}

export async function markNuxViewed(
  supabase: SupabaseClient<Database>,
  slug: NuxSlug,
  setter?: React.Dispatch<React.SetStateAction<boolean>>
) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session?.user) {
    throw new Error(
      "Supabase client must have an active session to mark nux as viewed."
    );
  }

  const { error } = await supabase
    .from("user_nux_views")
    .upsert([{ user_id: session.user.id, nux_slug: slug }]);

  if (error) {
    console.error(error);
    throw new Error(`Error marking nux ${slug} as viewed.`);
  }

  if (setter) {
    setter(false);
  }
}
